const caseReferenceDisplayLength = 8;

export function caseReferenceFormatter(caseReference: string): string {
  return caseReference.substring(0, caseReferenceDisplayLength);
}
